<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${location.name}` }} - {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="location" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "location-view-logs",

  components: { LogListTable },

  props: ["location"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
